import { Col, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import LoadingButton from "../../../components/Loading/LoadingButton";

export default function PayLinkCheckoutModalMobileVerification({
  body,
  isPending,
  onSubmit,
  onPrev,
  display,
}) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  return (
    <form
      onSubmit={handleSubmit(values => onSubmit(values))}
      className={display}
    >
      <div className="h-100 d-flex flex-column justify-content-center align-items-center gap-3">
        <Col xs={12} sm={6}>
          <Form.Label>شماره موبایل</Form.Label>
          <Form.Control disabled value={body?.mobile} />
        </Col>

        <Col xs={12} sm={6}>
          <Form.Label>کد پیامک شده را وارد نمایید:</Form.Label>
          <Form.Control
            type="number"
            className="text-center ltr"
            {...register("mobileVerificationCode", {
              required: "کد الزامی",
              minLength: { value: 6, message: "کد باید 6 رقمی باشد" },
              maxLength: { value: 6, message: "کد باید 6 رقمی باشد" },
            })}
          />
          {errors.mobileVerificationCode && (
            <p className="text-danger fs-small mb-0">
              {errors.mobileVerificationCode.message}
            </p>
          )}
        </Col>

        <Col
          xs={12}
          sm={6}
          className="d-flex flex-wrap align-items-center justify-content-center justify-content-md-between gap-1"
        >
          <LoadingButton
            className="btn-purple"
            center
            isLoading={isPending}
            title={isPending ? "در حال انتقال" : "ثبت و انتقال به درگاه بانکی"}
            type="submit"
          />

          <button className="btn btn-orange" type="button" onClick={onPrev}>
            تغییر شماره موبایل
          </button>
        </Col>
      </div>
    </form>
  );
}
